/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MarketFeedBingCognitive = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MarketFeedBingCognitive model module.
   * @module model/MarketFeedBingCognitive
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MarketFeedBingCognitive</code>.
   * @alias module:model/MarketFeedBingCognitive
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>MarketFeedBingCognitive</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MarketFeedBingCognitive} obj Optional instance to populate.
   * @return {module:model/MarketFeedBingCognitive} The populated <code>MarketFeedBingCognitive</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('MarketID')) {
        obj['MarketID'] = ApiClient.convertToType(data['MarketID'], 'Integer');
      }
      if (data.hasOwnProperty('Keywords')) {
        obj['Keywords'] = ApiClient.convertToType(data['Keywords'], 'String');
      }
      if (data.hasOwnProperty('SearchTypeID')) {
        obj['SearchTypeID'] = ApiClient.convertToType(data['SearchTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DailyLimit')) {
        obj['DailyLimit'] = ApiClient.convertToType(data['DailyLimit'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ModeratorID')) {
        obj['ModeratorID'] = ApiClient.convertToType(data['ModeratorID'], 'Integer');
      }
      if (data.hasOwnProperty('SWOTTopicID')) {
        obj['SWOTTopicID'] = ApiClient.convertToType(data['SWOTTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('PersonalTopicID')) {
        obj['PersonalTopicID'] = ApiClient.convertToType(data['PersonalTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('TrendTopicID')) {
        obj['TrendTopicID'] = ApiClient.convertToType(data['TrendTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('StakeholderID')) {
        obj['StakeholderID'] = ApiClient.convertToType(data['StakeholderID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('PESTELAreaID')) {
        obj['PESTELAreaID'] = ApiClient.convertToType(data['PESTELAreaID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} MarketID
   * @default 0
   */
  exports.prototype['MarketID'] = 0;
  /**
   * @member {String} Keywords
   * @default ''
   */
  exports.prototype['Keywords'] = '';
  /**
   * @member {Integer} SearchTypeID
   * @default 0
   */
  exports.prototype['SearchTypeID'] = 0;
  /**
   * @member {Integer} DailyLimit
   * @default 0
   */
  exports.prototype['DailyLimit'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ModeratorID
   * @default 0
   */
  exports.prototype['ModeratorID'] = 0;
  /**
   * @member {Integer} SWOTTopicID
   */
  exports.prototype['SWOTTopicID'] = undefined;
  /**
   * @member {Integer} PersonalTopicID
   */
  exports.prototype['PersonalTopicID'] = undefined;
  /**
   * @member {Integer} TrendTopicID
   */
  exports.prototype['TrendTopicID'] = undefined;
  /**
   * @member {Integer} StakeholderID
   */
  exports.prototype['StakeholderID'] = undefined;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} PESTELAreaID
   */
  exports.prototype['PESTELAreaID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


